import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import Navbar from 'src/components/navbar';
import { userHasPermission } from 'src/utils/context';
import config from 'config/config';

const getNavItems = ({ community, isSmallCommunity, currentUser, isAdmin }) => {
  const aboutItem = {
    link: `/${community.slug}/about`,
    isCrawlable: false,
    id: 'about',
    content: i18n.t('About'),
  };
  return [
    {
      isCrawlable: true,
      id: 'home',
      content: i18n.t('Home'),
      as: `/${community.slug}`,
      link: `/community/communityHome?slug=${community.slug}`,
    },
    !currentUser && aboutItem,
    !isSmallCommunity && {
      link: `/${community.slug}/posts`,
      isCrawlable: true,
      id: 'posts',
      content: i18n.t('Posts'),
    },
    config.discover.communities.includes(community.slug) && {
      link: `/${community.slug}/discover`,
      isCrawlable: false,
      id: 'discover',
      content: i18n.t('Discover'),
    },
    {
      link: `/${community.slug}/polls`,
      isCrawlable: false,
      id: 'polls',
      content: i18n.t('Polls'),
    },
    {
      link: `/${community.slug}/members`,
      isCrawlable: false,
      id: 'members',
      content: i18n.t('Members'),
    },
    currentUser && aboutItem,
    {
      link: `/search/posts?page=1&community=${community.communityId}`,
      isCrawlable: false,
      id: 'search',
      content: i18n.t('Search'),
      mobileOnly: true,
    },
    isAdmin && {
      link: `/${community.slug}/settings`,
      id: 'settings',
      content: (
        <span>
          <span className="icon icon-cog" /> {i18n.t('Admin')}
        </span>
      ),
    },
  ].filter(x => !!x);
};

const CommunityHeaderNavBar = ({ community, currentUser, currentPage, isSmallCommunity }) => {
  const isAdmin = userHasPermission(currentUser, 'ViewAdminMenu');
  return (
    <div className="community-header__navbar">
      <Navbar
        isCompact={true}
        items={getNavItems({ community, currentUser, isAdmin, isSmallCommunity })}
        selectedPage={currentPage}
      />
    </div>
  );
};

CommunityHeaderNavBar.propTypes = {
  community: PropTypes.object.isRequired,
  currentPage: PropTypes.string,
  currentUser: PropTypes.object,
  isSmallCommunity: PropTypes.bool,
};

CommunityHeaderNavBar.defaultProps = {
  currentUser: null,
  currentPage: '',
  isSmallCommunity: false,
};

export default CommunityHeaderNavBar;



// WEBPACK FOOTER //
// ./src/modules/community/shared/components/header/communityHeaderNavBar.js